import React, { Component } from 'react';

class HomeBanner extends Component {
    render(){
        if(this.props.visible){
            return(
                <div id="home-banner">
                    <div className="vb-discoverhotel-box">
                        <div className="vb-discoverhotel-button">
                            <a href="#discover" title="">
                                Discover hotel&nbsp;
                                <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.835938 0.445312L3.94531 3.55493L7.05493 0.445312" stroke="white"/>
                                </svg>	
                            </a>
                        </div>
                    </div>

                    <div className="vb-3col-v1">
                        <div className="col-1"></div>
                        <div className="col-2">
                            <h2>Wedding</h2>
                            <p>For those who want to marry in Pienza, in the heart of Tuscany and the Val d'Orcia, the Relais is the perfect choice!</p>
                            <a href="#weddings" title="">Read more</a>
                            <div className="tr"></div>
                        </div>
                        <div className="col-3"></div>
                    </div>
                </div>
            )
        }else{
            return false;
        }        
    }
}

export default HomeBanner;